<template>
    <div class="min-h-screen flex items-center justify-center py-5">
        <div class="w-full max-w-7xl overflow-hidden mx-4 pb-4">
            <div class="mb-6 flex justify-between items-center">
                <h2 class="text-title-md2 font-semibold text-black dark:text-white">Contractors</h2>
                <button 
                    @click="showBulkExportModal = true"
                    class="px-4 py-2 text-sm font-medium text-white bg-sky-600 rounded-md hover:bg-sky-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-sky-500"
                >
                    Bulk Export Profiles
                </button>
            </div>

            <TableContractors :contractors='contractors' />
        </div>
    </div>

    <BulkExportModal 
        :show="showBulkExportModal"
        :contractors="contractors"
        @close="showBulkExportModal = false"
        @export="handleBulkExport"
    />
</template>

<script>
import TableContractors from '@/components/marketplace/admin/TableContractors.vue'
import BulkExportModal from '@/components/marketplace/admin/BulkExportModal.vue'
import adminService from '@/services/marketplace/admin.service'

export default {
    name: 'AdminContractorList',
    inject: ['toggleLoading'],
    components: {
        TableContractors,
        BulkExportModal
    },
    data() {
        return {
            contractors: [],
            showBulkExportModal: false
        }
    },
    methods: {
        fetchContractors() {
            this.toggleLoading(true)
            adminService.getContractors()
            .then(response => {
                this.contractors = response.data
            })
            .catch((error) => {
                this.$router.push('/dashboard/auth');
            })
            .finally(() => {
              this.toggleLoading(false);
            })
        },
        async handleBulkExport(selectedIds) {
            try {
                this.toggleLoading(true);
                const response = await adminService.bulkExportHiddenProfiles(selectedIds);
                
                const url = window.URL.createObjectURL(new Blob([response.data], { type: "application/pdf" }));
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", `ScreenedBulkExport-${new Date().toISOString().split('T')[0]}.pdf`);
                document.body.appendChild(link);
                link.click();
                
                // Cleanup
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
                
                this.$root.notify(`Successfully exported ${selectedIds.length} profiles`, 'success');
            } catch (error) {
                console.error('Error exporting profiles:', error);
                this.$root.notify('Failed to export profiles. Please try again.', 'error');
            } finally {
                this.toggleLoading(false);
            }
        }
    },
    created() {
        this.fetchContractors()
    }
}
</script>